function vfitz_dropmenu_tab_init(params){
  var default_vfitz_menu_option_index = 0;
  document.querySelector('[vid="vfitzPlus-menu-dropdown"]').onchange = function(e){
    console.log("vfitzPlus-menu-dropdown onchange", e);
    document.querySelector('[vid="vfitzPlus-menu-dropdown"]').onchange = ()=>{}
    // console.log('asdfasdf',document.querySelector('.search-change-tap'))
    // console.log('func',document.querySelector('.search-change-tap').removeClass, document.querySelector('.search-change-tap'), document.querySelectorAll('.search-change-tap'), $('.search-change-tap').removeClass)
    $('.search-change-tap').removeClass('loading');
    $($('span.select2.select2-container')[0]).hide();
    vfitz_menu_change_by_tab();

    $('[vid="vfitzPlus-menu-dropdown"] select[level]').on("select2:select", function (event) {
        setTimeout(()=>{
          custom_select2_placeholder(default_vfitz_menu_option_index)
        },1)
    });
    
  }
  if(document.querySelector('.search-change-tap #ymm')){
    document.querySelector('.search-change-tap #ymm').onclick = function(){
      document.querySelector('.search-change-tap #vin').removeClass('active');
      document.querySelector('.search-change-tap #size').removeClass('active');
      document.querySelector('.search-change-tap #ymm').addClass('active');
      document.querySelector('.dropdown-layout').removeClass('vin');
      document.querySelector('.dropdown-layout').addClass('ymm');
      vfitz_menu_change_by_tab(0);
    }
  }

  if(document.querySelector('.search-change-tap #size')) {
    document.querySelector('.search-change-tap #size').onclick = function(){
      document.querySelector('.search-change-tap #vin').removeClass('active');
      document.querySelector('.search-change-tap #size').addClass('active');
      document.querySelector('.search-change-tap #ymm').removeClass('active');
      document.querySelector('.dropdown-layout').removeClass('vin');
      document.querySelector('.dropdown-layout').addClass('ymm');
      vfitz_menu_change_by_tab(1);
    }
  }
  
  if(document.querySelector('.search-change-tap #vin') ){
    document.querySelector('.search-change-tap #vin').onclick = function(){
      document.querySelector('.search-change-tap #ymm').removeClass('active');
      document.querySelector('.search-change-tap #size').removeClass('active');
      document.querySelector('.search-change-tap #vin').addClass('active');
      document.querySelector('.dropdown-layout').removeClass('ymm');
      document.querySelector('.dropdown-layout').addClass('vin');
    }
  }
    
  function vfitz_menu_change_by_tab(index) {
    default_vfitz_menu_option_index = index || 0;
    var default_vfitz_menu_value = $('[vid="vfitzPlus-menu-dropdown"] select[level="0"] option')[default_vfitz_menu_option_index].value;
    $('[vid="vfitzPlus-menu-dropdown"] select[level="0"]').val(default_vfitz_menu_value).trigger('change').trigger({
        type: 'select2:select',
        params: {
            data: {id:default_vfitz_menu_value}
        }
    });
    custom_select2_placeholder(default_vfitz_menu_option_index)
  }

  function custom_select2_placeholder(index) {
    if(0 == index){
      $($('span.select2.select2-container')[1]).find('.select2-selection__placeholder').text('Make');
      $($('span.select2.select2-container')[2]).find('.select2-selection__placeholder').text('Model');
      $($('span.select2.select2-container')[3]).find('.select2-selection__placeholder').text('Year');
    }
    
    if(1 == index){
      $($('span.select2.select2-container')[1]).find('.select2-selection__placeholder').text('Diameter');
      $($('span.select2.select2-container')[2]).find('.select2-selection__placeholder').text('Width');
      $($('span.select2.select2-container')[3]).find('.select2-selection__placeholder').text('Bolt Pattern');
    }    
  }
};